<script lang="ts">
  import { onMount, setContext } from "svelte";
  import { defaultConfiguration } from "$lib/elev8Api/configuration";
  import { configKey } from "$lib/elev8Api/configurationContext.svelte";
  import type { Content, Spot } from "$lib/elev8Api/contentTypes";
  import { initializeErrorReporter } from "$lib/errorHandling/errorReporter";
  import {
    allowedParentOrigins,
    parsePreviewMessage,
    READY_MESSAGE,
  } from "$lib/spot/previewMessage";

  import ErrorBoundary from "$lib/errorHandling/ErrorBoundary.svelte";
  import SpotRenderer from "$lib/spot/SpotRenderer.svelte";

  const config = $state(defaultConfiguration());
  setContext(configKey, config);

  let content: Content | undefined = $state();

  onMount(() => {
    initializeErrorReporter("preview");
    const allowedOrigins = allowedParentOrigins();

    function onMessage(event: MessageEvent) {
      const message = parsePreviewMessage(event, allowedOrigins);
      if (!message) return;
      // Each message fully describes the preview; anything omitted returns to defaults.
      Object.assign(config, defaultConfiguration(), {
        language: message.language ?? defaultConfiguration().language,
        screen: message.screen,
      });
      // Text edits update the mounted component in place; a media change remounts it.
      content = { ...message.content, id: message.content.asset_url ?? "preview" };
    }

    window.addEventListener("message", onMessage);
    window.parent.postMessage(READY_MESSAGE, "*");
    return () => window.removeEventListener("message", onMessage);
  });

  // Alerts live in the sidebar slot; everything else is the main slot.
  const spots: Spot[] = $derived(
    content
      ? [
          {
            duration: 0,
            contents:
              content.content_type === "alert"
                ? [{ content_type: "empty", id: "" }, content]
                : [content],
          },
        ]
      : []
  );
</script>

<ErrorBoundary>
  <main class="h-full w-full overflow-hidden">
    {#if content}
      <SpotRenderer spotIndex={0} {spots} addBufferTime={() => {}} />
    {/if}
  </main>
</ErrorBoundary>
